/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Next_NoteInputs */

const en_contact_next_note = /** @type {(inputs: Contact_Next_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We use your message to reply to you, and for nothing else.`)
};

const lv_contact_next_note = /** @type {(inputs: Contact_Next_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu ziņu izmantojam, lai Jums atbildētu, un nekam citam.`)
};

/**
* | output |
* | --- |
* | "We use your message to reply to you, and for nothing else." |
*
* @param {Contact_Next_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_next_note = /** @type {((inputs?: Contact_Next_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Next_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_next_note(inputs)
	return en_contact_next_note(inputs)
});